// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qUak","col":"styles_col__3hHIc"};